<template>
  <el-dialog width="820px" title="编辑产品"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="productEditVisible">
    <div class="details">
      <el-form  ref="productInfo"  size="small" v-loading="loading"   label-position="top"   label-width="100px"  :model="productInfo"  :rules="productInfoRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="product_name" label="产品名:">
              <!-- <p v-if="productId" v-text="productInfo.product_name"></p> -->
              <el-input  size="small"  placeholder="请输入产品名" v-model="productInfo.product_name" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="product_code" label="产品code:">
              <!-- <p v-if="productId" v-text="productInfo.product_code"></p> -->
              <el-input-number size="small"  placeholder="请输入产品code" v-model="productInfo.product_code" :controls="false"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>




        <el-form-item prop="modules_info" label="可选模块:">
          <div class="modules_info">


            <el-table class="custom_table" :data="productInfo.modules"  border ref="multipleTable" row-key="id">
              <el-table-column label="操作" prop="move" align="center" width="60px">
                <template slot-scope="{row}">
                  <img v-if="row.module_code != 13"  class="move" src="https://download.hecoos.com/enlightv/2025-26/d018a665251b26398d70f6e519a3abac.svg" alt="">
                </template>
              </el-table-column>
              <el-table-column label="模块名" prop="module_name" class-name="tableInputColumn" min-width="120px">
                <template slot-scope="{row}">
                  <el-input  :disabled="row.module_code == 13" placeholder="模块名" @blur="handleBlurModule(row,'module_name')" v-model="row.module_name" ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="模块code" prop="module_code" class-name="tableInputColumn"  width="100px">
                <template slot-scope="{row}">
                  <el-input :disabled="row.module_code == 13" placeholder="模块code" @blur="handleBlurModule(row,'module_code')"  v-model="row.module_code" ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="模块值" prop="module_value"  class-name="tableInputColumn"  min-width="120px">
                <template slot-scope="{row}">
                  <ul>
                    <li  v-for="(list,child_index) in row.module_values" :key="child_index">
                      <el-input :disabled="row.module_code == 13"  placeholder="模块值"  v-model="list.module_value" @blur="handleBlurModuleValue(row,list,'module_value')" ></el-input>
                    </li>
                  </ul>
                </template>
              </el-table-column>

              <el-table-column label="模块值code" prop="value_code" class-name="tableInputColumn"   width="105px">
                <template #default="{ row }">
                  <ul>
                    <li  v-for="(list,child_index) in row.module_values" :key="child_index">
                      <i v-if="row.module_code != 13" class="el-icon-error" @click="handleClickDelModuleValue(row,child_index)"></i>
                      <el-input :disabled="row.module_code == 13" placeholder="模块值code"  v-model="list.value_code"   @blur="handleBlurModuleValue(row,list,'value_code')" ></el-input>
                    </li>
                  </ul>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px" align="center">
                <template slot-scope="{row,$index}">
                  <el-link v-if="row.module_code != 13" :underline="false" type="primary" @click="handleClickAddModuleValues(row)">添加</el-link>
                  <el-link v-if="row.module_code != 13" :underline="false" class="ml-10" type="danger" @click="handleClickDelModule($index)">删除</el-link>
                </template>
              </el-table-column>

            </el-table>



<!--            <ul >-->
<!--              <li v-for="(item,index) in productInfo.modules" :key="index">-->
<!--                <i v-if="item.module_code != 13" class="el-icon-error" @click="handleClickDelModule(index)"></i>-->
<!--                <div class="field_name">-->
<!--                  <span v-if="item.id"  v-text="item.module_name"></span>-->
<!--                  <el-input v-if="!item.id" placeholder="请输入" @blur="handleBlurModule(item)" v-model="item.module_name" clearable></el-input>-->
<!--                </div>-->
<!--                <div class="field_value">-->
<!--                  <div class="list_field_value" v-for="(list,child_index) in item.module_values" :key="child_index">-->
<!--                    <i v-if="item.module_code != 13" class="el-icon-error" @click="handleClickDelModuleValue(item,child_index)"></i>-->
<!--                    <el-input  placeholder="请输入"  :disabled="item.module_code == 13"  v-model="list.module_value" @blur="handleBlurModuleValue(item,list)" clearable></el-input>-->
<!--                  </div>-->
<!--                  <div class="handle_add" v-if="item.module_code != 13" >-->
<!--                    <el-button  size="small" type="text" @click="handleClickAddModuleValues(item)">添加</el-button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
            <div class="handle_add_module mt-16 ">
              <el-button  size="small" type="primary" @click="handleClickAddModule">添加模块</el-button>
            </div>
          </div>

        </el-form-item>

      </el-form>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认</el-button>
    </div>

  </el-dialog>
</template>
<script>

import {adminProductList,adminProductEdit} from '@/api/api'
import {mapState} from "vuex";
import {convertToCurrentTimezone,convertToUTC} from '@/utils'
import Sortable from "sortablejs";
export default {
  name: 'product_edit',
  components: {

  },
  props: {
    productEditVisible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      default: 0,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,

      productInfoRules:{
        product_name: [ {required: true, message: "请输入产品名称"} ],
        product_code: [ {required: true, message: "请输入产品code"} ],
      },
      productInfo:{
        product_name:'',
        product_code:undefined,
        modules:[]
      }
    }
  },

  created() {
    if(this.productId){
      this.getAdminProductList()
    }else{
      this.productInfo.modules = [
        {
          "module_code": "13",
          "module_name": "最长离线运行时间",
          "module_values": [
            {
              "module_code": "13",
              "module_value": "默认(7天)",
              "value_code": "7"
            },
            {
              "module_code": "13",
              "module_value": "无需在线校验",
              "value_code": "0"
            }
          ]
        }
      ]
    }



  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {
    this.pullSort();
  },
  methods: {
    pullSort() {
      this.$nextTick(() => {
        const el = this.$refs.multipleTable.$el.querySelectorAll(
          "table.el-table__body > tbody"
        )[0];
        console.log(this.$refs.multipleTable.$el.querySelectorAll("table.el-table__body > tbody"))
        this.sortable = new Sortable.create(el, {
          handle: ".move", //格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
          animation: 600, //拖拽动画(毫秒)
          setData: function (dataTransfer) {
            dataTransfer.setData("Text", "");
          },
          // 开始拖拽
          onStart: (evt) => {},
          onMove: (evt) => {
            // 获取所有可排序的元素
            const items = evt.to.children;
            // 判断是否尝试移动到最后一个位置
            if (evt.dragged && evt.related && evt.related === items[items.length - 1]) {
              return false; // 阻止移动到最后一个位置
            }
            return true; // 允许其他移动
          },
          // 结束拖拽
          onEnd: (evt) => {
            const { oldIndex, newIndex } = evt;
            let data = JSON.parse(JSON.stringify(this.productInfo.modules));
            const targetRow = data.splice(evt.oldIndex, 1)[0];
            data.splice(evt.newIndex, 0, targetRow);
            this.productInfo.modules = data
          },
        });
      });
    },

    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },

    // 添加模块
    handleClickAddModule(){
      let json = {
        module_name:'',
        module_values:[
          {
            module_value:''
          }
        ]
      }
      this.productInfo.modules.splice(-1, 0, json);
    },
    // 添加模块值
    handleClickAddModuleValues(item){
        let json = {
          module_value:'',
          module_code:'',
        }
        item.module_values.push(json)
    },
    // 删除模块
    handleClickDelModule(index){
      this.productInfo.modules.splice(index, 1)
    },
    // 删除模块值
    handleClickDelModuleValue(item,index){
      if( item.module_values.length == 1){
         return  this.$message({
          message: `${item.module_name}模块至少保留一个模块值`,
          type: 'error',
          duration: 1000,
        });
      }
      item.module_values.splice(index, 1)
    },
    // 输入模块失去焦点
    handleBlurModule(item,type){
      let filterLength = this.productInfo.modules.filter(find => find[type] == item[type]).length
      let message = type == 'module_name' ?  `${item.module_name}模块名重复` :  `${item.module_name}模块code重复`
      if(filterLength > 1){
        this.$message({
          message: message,
          type: 'error',
          duration: 1000,
        });
      }
    },
    // 输入模块值失去焦点
    handleBlurModuleValue(item,list,type){
      let filterLength = item.module_values.filter(item => item[type] == list[type]).length
      let message = type == 'module_value' ?  `${item.module_name}模块值重复` :  `${item.module_name}模块值code重复`
      if(filterLength > 1){
        this.$message({
          message:message,
          type: 'error',
          duration: 1000,
        });
      }
    },
    // 获取产品列表
    getAdminProductList(){
      adminProductList().then(res => {
        if (res.code === 200) {
          this.productInfo = res.data.find(item => item.id === this.productId)
          // 1. 分离出非目标元素
          const others =  this.productInfo.modules.filter(item => item.module_code !== '13');
          // 2. 提取所有目标元素
          const targets =  this.productInfo.modules.filter(item => item.module_code === '13');
          // 3. 合并数组（非目标在前，目标在后）
          const sortedData = [...others, ...targets];
          this.productInfo.modules = sortedData
          console.log(this.productInfo);
        }
      }).catch((e) => {

      })
    },



    handleClickConfirm(){
      try {
        this.$refs.productInfo.validate(valid => {
            if (valid) {
              const isValid = this.validateModules(this.productInfo.modules);
              // console.log(this.productInfo.modules);
              // return  false
              this.BtnDisabled = true
              adminProductEdit(this.productInfo).then(res => {
                if (res.code === 200) {
                  this.$message({
                    message: '编辑成功',
                    type: 'success',
                    duration: 1000,
                    onClose: () => {
                      this.BtnDisabled = false
                      this.$emit('success')
                      this.$emit('update:productEditVisible', false)
                    }
                  })
                }else{
                  this.BtnDisabled = false
                }
              }).catch((e) => {
                this.BtnDisabled = false
              })
            }
        })

      } catch (error) {
        this.$message.error(error.message)
      }
      return false
      // if(this.productInfo.modules.findIndex(find => find.module_name == '')> -1 ){
      //   let index = this.productInfo.modules.findIndex(find => find.module_name == '')
      //   this.$message({
      //     message: `请输入第${index+1}个模块名`,
      //     type: 'error',
      //     duration: 1000,
      //   });
      //   return false
      // }
      // let flag = true
      // this.productInfo.modules.forEach((item,key) => {
      //   if(item.module_values.findIndex(find => find.module_value == '')> -1 && flag ){
      //     let index = item.module_values.findIndex(find => find.module_value == '')
      //     flag = false
      //     this.$message({
      //       message: `请输入第${key+1}个模块中，第${index+1}个模块值`,
      //       type: 'error',
      //       duration: 1000,
      //     });
      //   }
      // })
      // if(flag == false){return false}


    },

    validateModules(modules) {
      // 校验父级 module_name 和 module_code 是否为空或重复
      const moduleNames = new Set();
      const moduleCodes = new Set();

      for (const module of modules) {
        // 检查 module_name 和 module_code 是否为空
        if (!module.module_name || !module.module_code) {
          throw new Error(`模块的 模块名 或 模块code 不能为空！`);
        }

        // 检查 module_name 是否重复
        if (moduleNames.has(module.module_name)) {
          throw new Error(`模块名 "${module.module_name}" 重复！`);
        }
        moduleNames.add(module.module_name);

        // 检查 module_code 是否重复
        if (moduleCodes.has(module.module_code)) {
          throw new Error(`模块code "${module.module_code}" 重复！`);
        }
        moduleCodes.add(module.module_code);

        // 校验子级 module_values
        if (!module.module_values || module.module_values.length === 0) {
          throw new Error(`模块 ${module.module_name} 的 模块值 不能为空！`);
        }

        const valueNames = new Set();
        const valueCodes = new Set();

        for (const value of module.module_values) {
          // 检查 module_value 和 value_code 是否为空
          if (!value.module_value || !value.value_code) {
            throw new Error(`模块 ${module.module_name} 的子项 模块值 或 模块值code 不能为空！`);
          }

          // 检查 module_value 是否重复（当前模块内）
          if (valueNames.has(value.module_value)) {
            throw new Error(`模块 ${module.module_name} 的子项模块值 "${value.module_value}" 重复！`);
          }
          valueNames.add(value.module_value);

          // 检查 value_code 是否重复（当前模块内）
          if (valueCodes.has(value.value_code)) {
            throw new Error(`模块 ${module.module_name} 的子项模块值code "${value.value_code}" 重复！`);
          }
          valueCodes.add(value.value_code);
        }
      }

      return true; // 校验通过
    },

    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:productEditVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
::v-deep .el-form--label-top .el-form-item__label{
  padding-bottom: 0;
}
.el-select{
  display: block;
}
::v-deep .el-date-editor{
  width: 100%;

}
::v-deep .el-input-number{
  width: 100%;
  .el-input__inner{
    text-align: left;
  }
}
.modules_info{
  width: 100%;
  //ul{
  //  width: 100%;
  //  border-bottom: 1px solid #c5c5c5;
  //  box-sizing: border-box;
  //  li{
  //    border: 1px solid #c5c5c5;
  //    border-bottom: 0;
  //    box-sizing: border-box;
  //    display: flex;
  //    justify-content: space-between;
  //    position: relative;
  //    &:hover{
  //      .el-icon-error{
  //        display: block;
  //      }
  //    }
  //    .el-icon-error{
  //      cursor: pointer;
  //      position: absolute;
  //      right: -6px;
  //      top: -6px;
  //      z-index: 100;
  //      display: none;
  //    }
  //    .field_name{
  //      width: 220px;
  //      border-right: 1px solid #c5c5c5;
  //      padding: 5px;
  //      box-sizing: border-box;
  //      font-size: 13px;
  //      display: flex  ;
  //      align-items: center;
  //      font-weight: bold;
  //      line-height: 24px;
  //    }
  //    .field_value{
  //      width: calc(100% - 220px);
  //      padding: 5px 8px 0;
  //      box-sizing: border-box;
  //      display: flex;
  //      flex-wrap: wrap;
  //      .handle_add{
  //        margin-bottom: 4px;
  //      }
  //      .list_field_value{
  //        width: 135px;
  //        margin: 0 8px 4px 0;
  //        position: relative;
  //        &:hover{
  //          .el-icon-error{
  //            display: block;
  //          }
  //        }
  //        .el-icon-error{
  //          cursor: pointer;
  //          position: absolute;
  //          right: -3px;
  //          top: -2px;
  //          z-index: 100;
  //          display: none;
  //        }
  //      }
  //    }
  //  }
  //}
}


//element表格样式
::v-deep .custom_table {
  border-radius: 6px;
  .move{
    cursor: move;
    width: 16px;
  }
  th{
    background: rgba(237, 240, 244, 1);
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    padding-top: 7px;
    padding-bottom: 7px;

    .cell {
      padding: 0 12px;
      padding-left: 12px;
      padding-right: 12px;
    }

    &.is-leaf {
      border-color: rgba(0, 0, 0, 0.04);
    }
  }

  th.tableRequired {
    padding-left: 5px;

    .cell:after {
      content: '*';
      position: absolute;
      left: 4px;
      top: 0;
      color: rgba(228, 65, 68, 1);
    }
  }

  td{
    border-color: rgba(0, 0, 0, 0.04);
    padding: 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);

    .cell {
      padding: 0 12px;
      padding-left: 12px;
      padding-right: 12px;
      line-height: 40px;
      font-size: 14px;
      ul{
        width: 100%;
        li{
          position: relative;
          .el-icon-error{
            cursor: pointer;
            position: absolute;
            right: -10px;
            top: 0px;
            z-index: 100;
            display: none;
          }
          &:hover{
            .el-icon-error{
              display: block;
            }
          }
          &:before{
            position: absolute;
            width: calc(100% + 24px);
            content: ' ';
            height: 1px;
            left: -12px;
            bottom: 0;
            background: rgba(0, 0, 0, 0.04);
          }
          &:last-child:before{
            display: none;
          }
        }
      }
    }
  }

  td.tableInputColumn {
    padding: 0;

    .cell {
      line-height: initial;

      .el-input .el-input__inner {
        padding: 0;
        border: 0;
        background: transparent;
      }

      .el-textarea .el-textarea__inner {
        padding: 0;
        border: 0;
        background: transparent;
        font-family: "微软雅黑";

        &::placeholder {
          line-height: 42px;
        }
      }

      .el-input-number {
        width: 100%;

        &.el-input-number-left {
          .el-input__inner {
            text-align: left;
          }
        }

        .el-input__inner {
          text-align: right;
        }

      }

      .el-table__footer {
        .has-gutter {
          td {
            color: rgba(51, 51, 51, 1);
            font-weight: bold;
          }
        }
      }


    }

  }

  td.tableTagColumn {
    .cell {
      line-height: 24px;

      .el-tag {
        margin-right: 5px;
        margin-bottom: 2px;
        margin-top: 2px;
      }
    }

  }

  tr{

  }
}

</style>
